import { get as getLocalStorage, set as setLocalStorage } from 'lib/storage/isomorphicLocalStorage'

const POST_TRIP_REVIEW_NUDGE_DISMISSED_STORAGE_KEY = 'postTripReviewNudgeDismissed'

export function isPostTripReviewNudgeDismissed(): boolean {
  return getLocalStorage(POST_TRIP_REVIEW_NUDGE_DISMISSED_STORAGE_KEY) === true
}

export function dismissPostTripReviewNudge() {
  setLocalStorage(POST_TRIP_REVIEW_NUDGE_DISMISSED_STORAGE_KEY, true)
}
